import { Flex, Typography } from '@banhala/ui-kit';
import React from 'react';

type Props = {
  updatedAt: string;
};

export const PopularKeywordHeader = ({ updatedAt }: Props) => {
  return (
    <Flex.Row
      justifyContent="space-between"
      alignItems="center"
      padding={{ horizontal: 16 }}
      height={44}
    >
      <Typography type="subtitle1">인기 검색어</Typography>
      <Typography type="body2" color="content_secondary">
        {updatedAt}
      </Typography>
    </Flex.Row>
  );
};
